import { useCallback, useRef, useState } from 'react';

type ReturnValue = [string, (value: string) => void];

export const useDebounceSearchSetState = (
  setSearch: (value: string) => void,
  timeout = 500,
): ReturnValue => {
  const [inputValue, setInputValue] = useState<string>('');
  const typingTimeout = useRef<NodeJS.Timeout | null>(null);

  const onInputChange = useCallback(
    (value: string) => {
      setInputValue(value);

      if (typingTimeout.current) {
        clearTimeout(typingTimeout.current);
      }

      if (timeout <= 0) {
        setSearch(value.toLowerCase());
        return;
      }

      typingTimeout.current = setTimeout(() => {
        setSearch(value.toLowerCase());
      }, timeout);
    },
    [setSearch, timeout],
  );

  return [inputValue, onInputChange];
};
